import script from "./TipsPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./TipsPopover.vue?vue&type=script&setup=true&lang=ts"

import "./TipsPopover.vue?vue&type=style&index=0&id=53930a4e&lang=scss"

const __exports__ = script;

export default __exports__